
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6uNmH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ecdac60935587bea$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $ecdac60935587bea$export$2e2bcd8739ae039 = {
    'confluence.error.panel.refresh.app': "\u91CD\u65B0\u6574\u7406\u61C9\u7528\u7A0B\u5F0F",
    'confluence.error.panel.reload.page': "\u91CD\u65B0\u8F09\u5165\u9801\u9762",
    'confluence.icon.label': "\u5716\u793A",
    'confluence.modal.dialog.close.modal.button': "\u53D6\u6D88",
    'confluence.select.required.field.message': "\u9019\u662F\u5FC5\u586B\u6B04\u4F4D\u3002",
    'confluence.text.area.required.field.message': "\u9019\u662F\u5FC5\u586B\u6B04\u4F4D\u3002",
    'confluence.textfield.validator.email': "\u8ACB\u8F38\u5165\u6709\u6548\u7684\u96FB\u5B50\u90F5\u4EF6\u3002",
    'confluence.textfield.validator.number': "\u8ACB\u8F38\u5165\u6709\u6548\u7684\u6578\u5B57",
    'confluence.textfield.validator.required.field.message': "\u9019\u662F\u5FC5\u586B\u6B04\u4F4D\u3002",
    'confluence.textfield.validator.telephone': "\u8ACB\u8F38\u5165\u6709\u6548\u7684\u96FB\u8A71\u865F\u78BC\u3002",
    'confluence.threeLOPrompt.modal.access.required.title': "\u9700\u8981\u5B58\u53D6\u6B0A",
    'confluence.threeLOPrompt.modal.error.title': "\u932F\u8AA4",
    'confluence.threeLOPrompt.modal.no.authURL.error-message': "\u627E\u4E0D\u5230\u540C\u610F URL\u3002\u8ACB\u91CD\u65B0\u6574\u7406\u9801\u9762\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002",
    'confluence.threeLOPrompt.no.authURL.error-message': "\u627E\u4E0D\u5230\u540C\u610F URL\u3002\u8ACB\u91CD\u65B0\u6574\u7406\u9801\u9762\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002",
    'confluence.threeLOPrompt.use-auth.allow.access.button.text': "\u5141\u8A31\u5B58\u53D6",
    'confluence.threeLOPrompt.use-auth.configure.access.button.text': "\u8A2D\u5B9A\u5B58\u53D6\u6B0A",
    'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': "\u9A57\u8B49\u5931\u6557\u3002",
    'confluence.threeLOPrompt.use-auth.default.prompt.message': "\u82E5\u8981\u8B93 {appString} \u986F\u793A\uFF0C\u60A8\u5FC5\u9808\u5141\u8A31\u61C9\u7528\u7A0B\u5F0F\u4EE3\u8868\u60A8\u5B58\u53D6 Atlassian \u7522\u54C1\u3002",
    'confluence.threeLOPrompt.use-auth.external.auth.prompt.message': "{appString} \u9700\u8981\u5C0D\u60A8\u7684\u5E33\u6236\u53D6\u5F97\u5176\u4ED6\u5B58\u53D6\u6B0A\u3002",
    'confluence.threeLOPrompt.use-auth.external.auth.warning.message': "\u5916\u90E8\u9A57\u8B49\u8B66\u544A",
    'confluence.threeLOPrompt.use-auth.this.app.lower.message': "\u6B64\u61C9\u7528\u7A0B\u5F0F",
    'confluence.threeLOPrompt.use-auth.this.app.upper.message': "\u6B64\u61C9\u7528\u7A0B\u5F0F",
    'confluence.user.group.unknown.user.message': "\u672A\u77E5\u4F7F\u7528\u8005",
    'confluence.user.picker.empty.field.error.message': "\u9019\u662F\u5FC5\u586B\u6B04\u4F4D\u3002",
    'confluence.user.unknown.user.message': "\u672A\u77E5\u4F7F\u7528\u8005",
    'forge-ui.form.submit-button.text': "\u63D0\u4EA4"
};

});


//# sourceMappingURL=zh_TW.6858aa13.js.map
